import React, { useState } from 'react';
import apiClient from "../api/client";
import { Lock, Unlock, Loader } from 'lucide-react';


const SharePrivateGalleryButton = ({ matchId, token, iShared, theyShared, onUpdate }) => {
  const [loading, setLoading] = useState(false);
  const [hasShared, setHasShared] = useState(iShared);

  const handleToggle = async () => {
    if (!matchId || !token) return;
    setLoading(true);
    
    try {
      if (hasShared) {
        await apiClient.post(
          `/matches/${matchId}/unshare-private`,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setHasShared(false);
      } else {
        await apiClient.post(
          `/matches/${matchId}/share-private`,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setHasShared(true);
      }
      
      // Call parent update callback if provided
      if (onUpdate) {
        onUpdate({ iShared: !hasShared, theyShared });
      }
    } catch (error) {
      console.error('Failed to toggle private gallery sharing:', error);
      alert('Failed to update sharing settings. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const label = hasShared ? 'Private Gallery Shared' : 'Share Private Gallery';
  const subLabel = hasShared
    ? 'They can currently see your private photos & videos.'
    : theyShared
    ? "They've shared theirs. You can share yours too."
    : 'Share your private photos/videos when you feel comfortable.';

  return (
    <div className="flex flex-col gap-2 rounded-lg bg-gradient-to-br from-gray-900/80 to-gray-800/80 border border-gray-700 px-4 py-3 shadow-lg">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          {hasShared ? (
            <Unlock className="w-4 h-4 text-amber-400" />
          ) : (
            <Lock className="w-4 h-4 text-gray-400" />
          )}
          <span className="text-sm font-medium text-gray-200">{label}</span>
        </div>
        
        <button
          type="button"
          onClick={handleToggle}
          disabled={loading}
          className={`text-xs px-3 py-1.5 rounded-full font-medium transition-all ${
            hasShared
              ? 'border border-amber-500 text-amber-300 hover:bg-amber-500/10 hover:border-amber-400'
              : 'border border-emerald-500 text-emerald-300 hover:bg-emerald-500/10 hover:border-emerald-400'
          } disabled:opacity-60 disabled:cursor-not-allowed flex items-center gap-1`}
        >
          {loading ? (
            <>
              <Loader className="w-3 h-3 animate-spin" />
              <span>Saving...</span>
            </>
          ) : (
            <span>{hasShared ? 'Revoke Access' : 'Share Now'}</span>
          )}
        </button>
      </div>
      
      <p className="text-xs text-gray-400 leading-relaxed">{subLabel}</p>
      
      {theyShared && !hasShared && (
        <div className="mt-1 flex items-center gap-2 text-xs text-emerald-400 bg-emerald-500/10 rounded-md px-2 py-1.5">
          <span>✨</span>
          <span>They trust you with their private gallery!</span>
        </div>
      )}
    </div>
  );
};

export default SharePrivateGalleryButton;
